document.addEventListener('DOMContentLoaded', () => {
    const openMenuMobile = document.querySelector('.header__gapfy .open_nav_items');
    const closeMenuMobile = document.querySelector('.header__gapfy .close_nav_items');

    openMenuMobile.addEventListener('click', () => {
        const navItems = document.querySelector('.header__menu_mobile .nav_items');

        navItems.setAttribute('open', '');
        
        document.body.style.overflow = 'hidden';
    });

    closeMenuMobile.addEventListener('click', () => {
        const navItems = document.querySelector('.header__menu_mobile .nav_items');
        navItems.removeAttribute('open');
        
        document.body.style.overflow = 'auto';
    });

    const linksWithSubmenu = document.querySelectorAll('.nav_items [data-menu]');
    // const mainLinks = document.querySelector('.nav_items .main_items');

    linksWithSubmenu.forEach(link => {
        link.addEventListener('click', () => {
            const submenu = document.querySelector(`.header__menu_desktop .nav_items [data-submenu="${link.dataset.menu}"]`);
            const submenuMobile = document.querySelector(`.header__menu_mobile .nav_items [data-submenu="${link.dataset.menu}"]`);

            submenuMobile.toggleAttribute('closed');

            if (submenu) {
                submenu.toggleAttribute('closed');
                // mainLinks.toggleAttribute('closed');
            }

            const otherSubmenus = document.querySelectorAll('.nav_items [data-submenu]');
            otherSubmenus.forEach(otherSubmenu => {
                if (otherSubmenu !== submenu && otherSubmenu !== submenuMobile) {
                    otherSubmenu.setAttribute('closed', '');
                }
            });
        });
    });

    const sublinkBack = document.querySelectorAll('.nav_items .submenu_back__container');
    sublinkBack.forEach(back => {
        back.addEventListener('click', () => {
            const submenu = back.closest('[data-submenu]');
            if (submenu) {
                submenu.toggleAttribute('closed');
                // mainLinks.toggleAttribute('closed');
            }
        });
    });

    const searchIcon = document.querySelector('.header__gapfy .header__search .search__open');
    const searchClose = document.querySelector('.header__gapfy .header__search .search_input__container .search_close');

    searchIcon.addEventListener('click', () => {
        const searchInput = document.querySelector('.header__gapfy .header__search .search_input__container');
        searchInput.toggleAttribute('open');

        const otherSubmenus = document.querySelectorAll('.header__menu_desktop .nav_items [data-submenu]');
        otherSubmenus.forEach(otherSubmenu => {
            otherSubmenu.setAttribute('closed', '');
        });
    });

    searchClose.addEventListener('click', () => {
        const searchInput = document.querySelector('.header__gapfy .header__search .search_input__container');
        searchInput.toggleAttribute('open');
    });

    const header = document.querySelector('.header__section');
    let initialScroll = window.scrollY;

    window.addEventListener('scroll', () => {
        if (window.scrollY > initialScroll && window.scrollY > 100) {
            header.style.transform = 'translateY(-100%)';
            const otherSubmenus = document.querySelectorAll('.header__menu_desktop .nav_items [data-submenu]');
            otherSubmenus.forEach(otherSubmenu => {
                otherSubmenu.setAttribute('closed', '');
            });
        } else {
            header.style.transform = 'translateY(0)';
        }
        initialScroll = window.scrollY;
    });
});